import { all, put, select, takeEvery } from 'redux-saga/effects';
import * as Actions from './actions';
import { getOrgStationsApi } from '../../../../helpers/stationApi';
import { get } from 'lodash';

export function* getStation(action) {
    const config = yield select(state =>  state.config);
    const stationFetchResults = yield getOrgStationsApi(config.urlApi);
    const stationList = get(stationFetchResults, 'data');
    if (stationList) {
        yield put(Actions.setStation(stationList));
        yield put(Actions.setStatus(Actions.Status.LOADED));
        return ({
            status: Actions.Status.LOADED,
            data: stationList
        })
    } else {
        yield put(Actions.setStatus(Actions.Status.ERROR));
        return ({
            status: Actions.Status.ERROR
        })
    }
    //return data for playout
}

export default function* stationSaga() {
    const { ACTION_TYPES } = Actions;
    yield all([
        takeEvery(ACTION_TYPES.GET_STATION, getStation)
    ])
}
